import React from 'react'
import aboutContactImage from '../../img/home-banner-package.jpg'; 
import Conservation from './Conservation';

export default function ConversionMain() {
  return (
    <div>
      <div className="activity-hero-section">
             <img src={aboutContactImage} alt="About Us" className="activity-hero-image" />
            <div className="about-hero-overlay"></div>
            <div className="about-hero-content">
              <h1>Package</h1>
              <div className="breadcrumb">
                <span>Package</span> &gt; <span>Conservation</span>
              </div>
            </div>
          </div>
          <Conservation/>
    </div>
  )
}
